import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useLocation } from 'react-router-dom';
const ScrollToTop = () => {
    const { pathname } = useLocation();
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);


    return (
        <>
            <div
                onClick={handleScrollToTop}
                className='scroll_to_top pulsate-fwd'
                // style={{
                //     position: "fixed",
                //     width: "25px",
                //     height: "25px",
                //     bottom: "30px",
                //     right: "10px",
                //     backgroundColor: "#333",
                //     color: "#fff",
                //     borderRadius: "50%",
                //     padding: "12px",
                //     cursor: "pointer",
                //     boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                //     zIndex:9999,
                // }}
            >
                <FontAwesomeIcon className='' icon={faChevronUp} />
            </div>
        </>
    );
};

export default ScrollToTop